import { useContext, useEffect } from "react"
import { RoomContext } from "../../../Context/RoomContext"
import React from "react"
import { v4 as uuidv4 } from "uuid"
import { ScanQr } from "./ScanQr"
import checkSessionStorage from "../../../utils/checkSessionStorage"

const RoomWizard = props => {
  const { data, state } = useContext(RoomContext)
  const [roomData] = data
  const [roomState] = state

  //this roomId is newly created and can be used on initial load
  const roomIdFromUuid = uuidv4()

  //this roomId comes from the BE when the room is created. when a name is provided from FE to BE, this name will be used as roomId
  const roomIdFromBE = props?.id
  const roomIsCreated = roomIdFromBE

  //this roomId comes from sessionStorage and can be used in case of a refresh
  const sessionIsDefined = checkSessionStorage()
  const roomIdFromSession = sessionIsDefined
    ? sessionStorage.getItem("roomId") || ""
    : ""

  const roomIdGoingToBE = roomIdFromSession || roomIdFromUuid
  const [roomIdIsSet, setRoomIdIsSet] = React.useState(false)
  useEffect(() => {
    if (!roomIdIsSet) {
      setRoomIdIsSet(true)
      props.onNameEnter(roomIdGoingToBE) //creates the room in the BE (and sets the roomId there)(on initial load). On refresh the room will be re-activated in the BE.
      console.log("%croomId sent to BE: ", "color: #bada55", roomIdGoingToBE)

      if (roomIdFromSession === "") {
        sessionStorage.setItem("roomId", roomIdGoingToBE)
        console.log("roomId to session: ", roomIdGoingToBE)
      }
    }
    // eslint-disable-next-line
  }, [roomIdFromSession])

  //manually triggered by the host, available when all 4 clients are in the room
  const handleStart = () => {
    props.onStart()
  }

  if (roomIsCreated)
    return (
      <ScanQr
        roomId={roomIdFromBE}
        roomData={roomData}
        roomState={roomState}
        handleStart={handleStart}
        gameProps={props?.gameProps}
        gameData={props?.gameData}
      />
    )
  else
    return (
      <div>
        <div>Connecting ... </div>
      </div>
    )
}
export default RoomWizard
